import React, { useEffect } from "react";
import WOW from "wowjs";

function Features() {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);
  return (
    <section id="features" className="feature-section feature-style-5">
      <div className="container">

        {/* Title */}
        <div className="row justify-content-center">
          <div className="col-xxl-5 col-xl-5 col-lg-7 col-md-8 text-center">
            <div className="section-title mb-60">
              <h3 className="mb-15 wow fadeInUp" data-wow-delay=".2s">
                Why Choose Us ?
              </h3>
              <p className="wow fadeInUp" data-wow-delay=".4s">
                Innovative online test preparation platform dedicated to providing affordable, customized, and effective learning solutions for students preparing for the SAT, ACT, AP's and more.
              </p>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="row">

          {/* CARD 1 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="single-feature animated fadeInUp wow"
              data-wow-delay=".2s"
              style={{ animationDelay: "0.2s" }}
            >
              <div className="icon">
                <i className="lni lni-vector"></i>
                <svg width="110" height="72" viewBox="0 0 110 72">
                  <path d="M110 54.7589C110 85.0014 85.3757 66.2583 55 66.2583C24.6243 66.2583 0 85.0014 0 54.7589C0 24.5164 24.6243 0 55 0C85.3757 0 110 24.5164 110 54.7589Z" fill="#EBF4FF"/>
                </svg>
              </div>
              <div className="content">
                <h5>Proven Track Record</h5>
                <p>We have a proven history of success, with countless students achieving their academic goals. Our consistent results reflect structured learning, expert guidance, and a student-centric approach.</p>
              </div>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="single-feature animated fadeInUp wow"
              data-wow-delay=".4s"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="icon">
                <i className="lni lni-pallet"></i>
                <svg width="110" height="72" viewBox="0 0 110 72">
                  <path d="M110 54.7589C110 85.0014 85.3757 66.2583 55 66.2583C24.6243 66.2583 0 85.0014 0 54.7589C0 24.5164 24.6243 0 55 0C85.3757 0 110 24.5164 110 54.7589Z" fill="#EBF4FF"/>
                </svg>
              </div>
              <div className="content">
                <h5>Expert Instructors</h5>
                <p>Our instructors are experts in their fields, with years of experience and a passion for helping students succeed. They provide personalized support and guidance tailored to your individual needs.</p>
              </div>
            </div>
          </div>

          {/* CARD 3 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="single-feature animated fadeInUp wow"
              data-wow-delay=".6s"
              style={{ animationDelay: "0.6s" }}
            >
              <div className="icon">
                <i className="lni lni-stats-up"></i>
                <svg width="110" height="72" viewBox="0 0 110 72">
                  <path d="M110 54.7589C110 85.0014 85.3757 66.2583 55 66.2583C24.6243 66.2583 0 85.0014 0 54.7589C0 24.5164 24.6243 0 55 0C85.3757 0 110 24.5164 110 54.7589Z" fill="#EBF4FF"/>
                </svg>
              </div>
              <div className="content">
                <h5>Comprehensive Approach</h5>
                <p>We offer a comprehensive approach to education, addressing not only test preparation but also academic tutoring and homework help. Whatever your needs, we have the resources and expertise to support you.</p>
              </div>
            </div>
          </div>

          {/* CARD 4 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="single-feature animated fadeInUp wow"
              data-wow-delay=".2s"
              style={{ animationDelay: "0.2s" }}
            >
              <div className="icon">
                <i className="lni lni-code-alt"></i>
                <svg width="110" height="72" viewBox="0 0 110 72">
                  <path d="M110 54.7589C110 85.0014 85.3757 66.2583 55 66.2583C24.6243 66.2583 0 85.0014 0 54.7589C0 24.5164 24.6243 0 55 0C85.3757 0 110 24.5164 110 54.7589Z" fill="#EBF4FF"/>
                </svg>
              </div>
              <div className="content">
                <h5>Personalized Learning</h5>
                <p>Every student is unique, and so is our approach. We design customized learning plans based on individual strengths, weaknesses, and academic goals. This ensures focused progress and better outcomes.</p>
              </div>
            </div>
          </div>

          {/* CARD 5 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="single-feature animated fadeInUp wow"
              data-wow-delay=".4s"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="icon">
                <i className="lni lni-lock"></i>
                <svg width="110" height="72" viewBox="0 0 110 72">
                  <path d="M110 54.7589C110 85.0014 85.3757 66.2583 55 66.2583C24.6243 66.2583 0 85.0014 0 54.7589C0 24.5164 24.6243 0 55 0C85.3757 0 110 24.5164 110 54.7589Z" fill="#EBF4FF"/>
                </svg>
              </div>
              <div className="content">
                <h5>Flexible Learning Options</h5>
                <p>We offer flexible schedules and multiple learning modes, including online and in-person sessions. This allows students to learn at their own pace without compromising school or personal commitments.</p>
              </div>
            </div>
          </div>

          {/* CARD 6 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="single-feature animated fadeInUp wow"
              data-wow-delay=".6s"
              style={{ animationDelay: "0.6s" }}
            >
              <div className="icon">
                <i className="lni lni-code"></i>
                <svg width="110" height="72" viewBox="0 0 110 72">
                  <path d="M110 54.7589C110 85.0014 85.3757 66.2583 55 66.2583C24.6243 66.2583 0 85.0014 0 54.7589C0 24.5164 24.6243 0 55 0C85.3757 0 110 24.5164 110 54.7589Z" fill="#EBF4FF"/>
                </svg>
              </div>
              <div className="content">
                <h5>Continuous Assessment</h5>
                <p>Regular assessments help track progress and identify improvement areas. Our detailed feedback keeps students and parents informed. This continuous evaluation ensures consistent academic growth.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Features;